import Component from './Component';
import React from 'react';
import {Button} from 'react-bootstrap';

export default class AddButton extends Component {

	static contextTypes = {
		user: React.PropTypes.object
	};

	render() {
		if (this.props.resource && !this.context.user.isAllowed(this.props.resource, 'insert')) {
			return false;
		}

		return (
			<Button href={'/'+this.props.link+'/0'} onClick={(e) => this.props.onClick(e)}>
				<i className="fa fa-plus position-left"/>{this.props.children}
			</Button>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/AddButton.js